import url from 'url';
import { imgixDomain } from 'commons/constants';

const addDomainToPath = path => url.resolve(imgixDomain, path);

export default addDomainToPath;
